<template>
  <div id="carte-evenements" style="height:100vh; width:100vw">
    <l-map ref="map" :zoom="6" :center="[47.41322, -1.219482]" :options="mapOptions">
      <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          layer-type="base"
          name="OpenStreetMap"
      ></l-tile-layer>
      <v-tilelayer-googlemutant apikey="AIzaSyBGtYSbTSq7e_V9CRWp4Mp85FdPtXRYAn8&callback=Function.prototype" lang="fr" region="FR" :options="googlemutantoptionsobject">
      </v-tilelayer-googlemutant>
      <v-marker-cluster ref="cluster" :options="clusterOptions">
        <l-marker  v-for="(marker , index) in markers" :lat-lng="[marker.acfEvent.dates[0].latitude, marker.acfEvent.dates[0].longitude]" :key="marker.id+index" :ref="marker.id+index">
          <l-icon
              :icon-size="[10 , 10]"
              :icon-anchor="[5 , 10]"
              icon-url="/images/pin.svg"
              :popup-anchor="[0 , -10]"
          />
          <l-popup :options="popupOptions">
            <MarkerPopup :contenu="marker"/>
          </l-popup>
        </l-marker>
      </v-marker-cluster>
    </l-map>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import Vue2LeafletGoogleMutant from 'vue2-leaflet-googlemutant'
import { LMap, LTileLayer , LMarker , LIcon , LPopup } from 'vue2-leaflet';
import MarkerPopup from "./MarkerPopup";
export default {
  name: "Carte",
  components: {
    MarkerPopup,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    'v-tilelayer-googlemutant': Vue2LeafletGoogleMutant,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  props : ['markers'],
  data() {
    return {
      coordinates : [],
      mapOptions : {
        scrollWheelZoom: false
      },
      clusterOptions : {
        polygonOptions: {
          fillColor: '#0089A1',
          color: '#0089A1',
          weight: 0.5,
          opacity: 1,
          fillOpacity: 0.5
        }
      },
      popupOptions : {
        maxWidth : 360,
        minWidth : 360,
        closeButton : false,
      },
      zoom: 2,
      googlemutantoptionsobject : {
        type: "roadmap",
        styles: [
          {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
              {
                "weight": "1.50"
              },
              {
                "visibility": "on"
              },
              {
                "color": "#003e4b"
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#ff0f0f"
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "all",
            "stylers": [
              {
                "color": "#ff0000"
              },
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#474747"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "off"
              },
              {
                "color": "#8d2e2e"
              },
              {
                "weight": "1.00"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#ffed00"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "color": "#da346c"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              },
              {
                "visibility": "simplified"
              },
              {
                "weight": "0.50"
              },
              {
                "color": "#e15c89"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "simplified"
              },
              {
                "color": "#ff0000"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "simplified"
              },
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              },
              {
                "color": "#003e4b"
              },
              {
                "weight": "0.01"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#0089a1"
              },
              {
                "visibility": "on"
              }
            ]
          }
        ],
      },
    };
  },
  watch : {
    markers: function () {
      this.setMarkers()
    }
  },
  created() {
    this.setMarkers()
  },
  methods : {
    setMarkers() {
      this.coordinates = []
      this.markers.forEach( (point) => {
        const coordinates = [point.acfEvent.dates[0].latitude , point.acfEvent.dates[0].longitude]
        this.coordinates.push(coordinates)
      })
      this.centerMap()
    },
    centerMap() {
      this.$nextTick( () => {

        if(this.coordinates.length > 0) {
          this.$refs.map.mapObject.fitBounds(this.coordinates)
        }

      })

    },
  }
}
</script>

<style lang="scss">


</style>